import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f46cd6a")

_pushScopeId("data-v-1f46cd6a")
const _hoisted_1 = {
  key: 0,
  class: "wx-web-login__placeholder"
}
const _hoisted_2 = { class: "wx-web-login__placeholder-text" }
const _hoisted_3 = { class: "wx-web-login__error-text" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "wx-web-login__error-retry" }, "重新加载二维码", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "wx-web-login",
    style: _ctx.containerStyle
  }, [
    _withDirectives(_createVNode("div", {
      id: _ctx.containerId,
      class: "wx-web-login__qrcode"
    }, null, 8, ["id"]), [
      [_vShow, _ctx.status === 'ready']
    ]),
    (_ctx.status === 'loading')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.loadingText), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.status === 'error')
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "wx-web-login__error",
          role: "button",
          tabindex: "0",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args))),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)), ["enter"]))
        }, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.errorText), 1),
          _hoisted_4
        ], 32))
      : _createCommentVNode("", true)
  ], 4))
})